import { cn } from "@omni/utils/styles";
import React from "react";

export type ContainerProps = {
    children: React.ReactNode;
    className?: string;
    as?: React.ElementType;
    ref?: React.Ref<HTMLDivElement> | React.Ref<React.ElementType>;
};

const Container = ({
    children,
    className,
    as: Component = "div",
    ...props
}: ContainerProps) => {
    const containerClass = "tw:w-full";

    return (
        <Component
            className={cn(containerClass, className)}
            {...props}
        >
            {children}
        </Component>
    );
};

export { Container };
